<template>
  <subscriptionplanDetails></subscriptionplanDetails>
</template>

<script>
import SubscriptionplanDetails from "@/components/MasterSetup/subscriptionplan/SubscriptionplanDetails"
export default {
    components:{
        SubscriptionplanDetails
    }
}
</script>

<style>

</style>